import { fetchApi } from '@/config/api'
import type { Pack, CreatePackInput, UpdatePackInput } from '@/types/pack'

/**
 * Récupère tous les packs d'un vendeur
 */
export async function getPacksByVendeur(idVendeur: number): Promise<Pack[]> {
  const query = `
    query GetPacksByVendeur($idVendeur: Int!) {
      packsByVendeur(id_vendeur: $idVendeur) {
        id_pack
        id_vendeur
        titre
        p1
        p2
        p3
        p4
        p5
        p6
        p7
        p8
        p9
        p10
        p11
        p12
      }
    }
  `

  const variables = { idVendeur }
  const response = await fetchApi(query, variables)
  return response.packsByVendeur
}

/**
 * Récupère TOUS les packs (pour les templates)
 */
export async function getAllPacks(): Promise<Pack[]> {
  const query = `
    query GetAllPacks {
      allPacks {
        id_pack
        id_vendeur
        titre
        p1
        p2
        p3
        p4
        p5
        p6
        p7
        p8
        p9
        p10
        p11
        p12
      }
    }
  `

  const response = await fetchApi(query)
  return response.allPacks
}

/**
 * Récupère un pack par son ID
 */
export async function getPackById(idPack: number): Promise<Pack> {
  const query = `
    query GetPack($id: Int!) {
      pack(id: $id) {
        id_pack
        id_vendeur
        titre
        p1
        p2
        p3
        p4
        p5
        p6
        p7
        p8
        p9
        p10
        p11
        p12
      }
    }
  `

  const variables = { id: idPack }
  const response = await fetchApi(query, variables)
  return response.pack
}

/**
 * Crée un nouveau pack
 */
export async function createPack(input: CreatePackInput): Promise<Pack> {
  const mutation = `
    mutation CreatePack($input: CreatePackInput!) {
      createPack(input: $input) {
        id_pack
        id_vendeur
        titre
        p1
        p2
        p3
        p4
        p5
        p6
        p7
        p8
        p9
        p10
        p11
        p12
      }
    }
  `

  const variables = { input }
  const response = await fetchApi(mutation, variables)
  return response.createPack
}

/**
 * Met à jour un pack existant
 */
export async function updatePack(input: UpdatePackInput): Promise<Pack> {
  const mutation = `
    mutation UpdatePack($input: UpdatePackInput!) {
      updatePack(input: $input) {
        id_pack
        id_vendeur
        titre
        p1
        p2
        p3
        p4
        p5
        p6
        p7
        p8
        p9
        p10
        p11
        p12
      }
    }
  `

  const variables = { input }
  const response = await fetchApi(mutation, variables)
  return response.updatePack
}

export async function packHasProducts(id: number): Promise<boolean> {
  const query = `
    query PackHasProducts($id: Int!) {
      packHasProducts(id: $id)
    }
  `

  const response = await fetchApi(query, { id: Number(id) })
  return response.packHasProducts
}

export async function deletePack(id: number, replacementId: number | null): Promise<boolean> {
  const mutation = `
    mutation DeletePack($id: Int!, $replacementId: Int) {
      deletePack(id: $id, replacementId: $replacementId)
    }
  `

  const response = await fetchApi(mutation, {
    id: Number(id),
    replacementId: replacementId === null ? null : Number(replacementId),
  })
  return response.deletePack
}
